import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";
import { UserWithMyRooms } from "@api/src/types/user";
interface State {
  user: UserWithMyRooms | null;
}

interface Action {
  setUser: (user: UserWithMyRooms | null) => void;
}

const useUser = create<State & Action>()(
  devtools(
    persist(
      (set): State & Action => ({
        user: null,
        setUser: (user: UserWithMyRooms | null) => set({ user }),
      }),
      {
        name: "medspot-zustand-user-store",
        version: 1,
        storage: createJSONStorage(() => window.localStorage),
      }
    )
  )
);

export default useUser;
